<template>
  <div class="container content">
    <h1 class="title">
      {{ $store.state.company.name }}
      <button class="button is-primary"
              :disabled="apiBusy"
              @click="refreshAll()">
        Check for New Orders
      </button>
      <small style="font-weight: 300; font-size: 1.25rem; white-space: nowrap">(last checked {{ last_check }})</small>
    </h1>

    <nav class="level level-links has-text-centered">
      <!--
      <div class="level-item">
        <router-link :to="{name:'new-order'}" class="level-item-link">
          <p class="heading">Enter New Order</p>
          <p class="title"><i class="fa fa-plus"></i></p>
        </router-link>
      </div>
      --->
      <div class="level-item">
        <router-link :to="{name:'orders'}" class="level-item-link">
          <p class="heading">{{ newOrders.length | pluralize("New Order") }}</p>
          <p class="title">{{ newOrders.length }}</p>
        </router-link>
      </div>
      <div class="level-item">
        <router-link :to="{name:'printed-orders'}" class="level-item-link">
          <p class="heading">Printed Orders</p>
          <p class="title">{{ printedOrders.length }}</p>
        </router-link>
      </div>
      <div class="level-item">
        <router-link :to="{name:'orders'}" class="level-item-link">
          <p class="heading">All Orders</p>
          <p class="title">{{ allNonVoidedOrders.length }}</p>
        </router-link>
      </div>
      <div class="level-item">
        <router-link :to="{name:'requests'}" class="level-item-link">
          <p class="heading">{{ newCatalogRequests.length | pluralize("Catalog Request") }}</p>
          <p class="title">{{ newCatalogRequests.length }}</p>
        </router-link>
      </div>
      <div class="level-item">
        <router-link :to="{name:'subscriptions'}" class="level-item-link">
          <p class="heading">{{ subscriptions.length | pluralize("Subscription") }}</p>
          <p class="title">{{ subscriptions.length }}</p>
        </router-link>
      </div>
      <div class="level-item">
        <router-link :to="{name:'users'}" class="level-item-link">
          <p class="heading">{{ users.length | pluralize("Account") }}</p>
          <p class="title">{{ users.length }}</p>
        </router-link>
      </div>
    </nav>

    <hr />

  </div>
</template>

<script>
import {mapGetters}  from "vuex"
import moment        from "moment/moment.js"

export default {
  data() {
    return {
      last_check: 'never',
      check_interval: 0,
      load_check: 0,
    }
  },
  mounted() {
    this.getLastRefresh()
    this.check_interval = setInterval(this.getLastRefresh, 1000)
  },
  methods: {
    getLastRefresh() {
      this.last_check = moment(this.ordersLastSync).fromNow()
    },
    refreshAll() {
      if (this.orders.length > 500) {
        let confirm = window.confirm("Are you sure? This may take a minute.")
        if (confirm) {
          this.$store.dispatch('REFRESH_ORDERS').then(data => {
            this.reloadChart();
          })
        }
      }
      else {
        this.$store.dispatch('REFRESH_ORDERS').then(data => {
          this.reloadChart();
        })
      }
    },
  },
  computed: Object.assign({}, mapGetters([
    'loadComplete',
    'apiBusy',
    'isSuperUser',
    'pages',
    'products',
    'bundles',
    'categories',
    'items',
    'tags',
    'images',
    'newOrders',
    'orders',
    'ordersLastSync',
    'allNonVoidedOrders',
    'printedOrders',
    'archivedOrders',
    'voidedOrders',
    'newCatalogRequests',
    'subscriptions',
    'users',
  ]))
};
</script>

<style lang="scss">
  .inset-input {
    border: none;
    background: transparent;
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    padding: 0;
    margin: 0;
    width: 60px;
    text-align: center;
    display: inline-block;
  }

  .chart-header {
    margin-bottom: 1rem;

    &:after {
      content: ' ';
      display: table;
      clear: both;
    }
  }

  .chart-select {
    display: inline-block;
    vertical-align: middle;
    background: none;
    border: none;
    outline: none;
    margin: 0 !important;
    font-weight: 700;

    &:focus, &:hover, &:active {
      outline: none;
    }
  }

  .chart-options {
    color: #888;
    display: inline-block;
    float: right;
    vertical-align: middle;
    font-size: 0.9rem;

    input {
      display: inline-block;
      vertical-align: middle;
    }

    padding-bottom: 5px;
    padding-top: 1rem;
    border-bottom: 1px solid #ddd;
  }

  .chart-options-save {
    display: inline-block;
    vertical-align: middle;
  }

  .date-range {
    display: inline-block;
    text-align: center;

    .date-input {
      text-align: center;
      display: inline-block;
      vertical-align: -1px;
      background: none;
      border: none;
      box-shadow: none;
      width: 100px;
      font-size: 0.85rem;
      user-select: none;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .stats-table {
    td {
      padding: 0.5em 0.5em !important;

      &:first-child {
        text-align: right;
      }
    }
  }

  @media (max-width: 768px) {
    .level {
      display: flex;
      flex-wrap: wrap;
    }
    .level-item {
      flex-grow: 1;
      min-height: 80px;
    }
  }

  @media screen and (max-width: 768px) {
    .level-item:last-child {
      margin-bottom: 0.75rem !important;
    }
  }

  .calendar-nav-previous-month, .calendar-nav-next-month {
    background-color: transparent !important;
  }

  .calendar {
    min-height: 500px;
  }

  .level-links {
    display: flex;
    flex-wrap: wrap;

    .heading {
      font-size: 0.8em;
    }

    .level-item {
      min-width: 150px;
    }
  }

  .level-item-link {
    display: block;
    background-color: transparent;
    border-radius: 0.25em;
    padding: 0.5em;
    transition: all 0.5s ease;

    &:hover {
      background-color: #fff;
      color: #f15a5c;
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?644abc00